import React from 'react';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import style from './pendingLeadsCard.module.scss';
import LeadsAccountIndicator from './LeadsAccountIndicator';
import Trans from '@/components/shared/Trans';
import translations from '../../../Dashboard.trans.json';
import CustomTooltip from '@/components/propertyConfigurator/attributesSection/personalizedAttributes/customTootlip/CustomTooltip';

function RemainingEntitiesCard({ leads, type }) {
  const remainingLeadsType = Trans(
    translations,
    type === 'agent' ? 'OtherAgents' : 'OtherBranches'
  );
  const agentList = leads.map(
    (lead) => `${lead.agent_name || lead.branch_name}: ${lead.count}`
  );
  const totalCount = leads.reduce((acc, lead) => acc + lead.count, 0);
  return (
    <Box className={style.pendingLeadsCard}>
      <CustomTooltip isTextList content={{ text: agentList }} bottom>
        <Text>{remainingLeadsType}</Text>
      </CustomTooltip>
      <LeadsAccountIndicator count={totalCount} />
    </Box>
  );
}

export default RemainingEntitiesCard;
